import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import { Grid, Menu, Segment, Message } from "semantic-ui-react";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getNewInvoiceNumber } from "../helpers";
import { loadInvoiceForEdit, setDefaultInvoiceBuilderLogo } from "../builder/actions";

import TopNav from "../../common/containers/top-nav";
import { loadStampRoll } from "../../stamp/roll/actions";
import InvoiceBuilderContainer from "../builder/index.container";
import StampRollContainerEditor from "../../stamp/roll/containers/editor";
import { isCompanyFeatureActive } from "utilities/dist/company/helpers";
import { CompanyFeatures } from "utilities/dist/company/constants";

const InvoicePageCreate = () => {
    const dispatch = useDispatch();

    const [number, setNumber] = useState(null);
    const { stamp, stampLoading, isCustomerInvoiceNumberingActive, customer } = useSelector(
        ({ invoiceBuilder, stampWarning, auth }) => ({
            stampLoading: stampWarning.isLoading,
            customer: invoiceBuilder.customer,
            stamp: stampWarning.data,
            isCustomerInvoiceNumberingActive: isCompanyFeatureActive(
                auth.user.company,
                CompanyFeatures.CUSTOMER_INVOICE_NUMBERING
            ),
        })
    );

    const initialLoad = () => {
        dispatch(loadStampRoll());
        dispatch(loadInvoiceForEdit(null));

        // get new number for the invoice
        // only load on initial load when customer specific numbering is not enabled
        if (!isCustomerInvoiceNumberingActive) getNewInvoiceNumber().then(setNumber);
        dispatch(setDefaultInvoiceBuilderLogo());
    };

    useEffect(initialLoad, []);
    useEffect(() => {
        if (customer?.id && isCustomerInvoiceNumberingActive) {
            getNewInvoiceNumber(customer.id).then(setNumber);
        }
    }, [customer?.id]);

    const invoiceNumber =
        isCustomerInvoiceNumberingActive && customer ? `${customer.id}-${number}` : number;

    return (
        <Grid>
            <TopNav
                headerIcon="newspaper"
                subheader="Create New Invoice"
                headerContent={`New Invoice #${number ? invoiceNumber : "..."}`}
                extraButtons={() => (
                    <>
                        <Menu.Item
                            as={Link}
                            to="/invoice"
                            icon="chevron left"
                            name="All Invoices"
                        />
                    </>
                )}
            />

            <Grid.Column mobile={16}>
                {stampLoading ? (
                    <Segment className="hp-30" loading />
                ) : isEmpty(stamp.firstAvailableStamp) ? (
                    <Grid>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Message
                                warning
                                as={Link}
                                className="db"
                                to="/stamp/roll"
                                header="Stamp roll missing"
                                content="Please add your current stamp roll before creating an invoice"
                            />
                            <StampRollContainerEditor />
                        </Grid.Column>
                    </Grid>
                ) : (
                    <InvoiceBuilderContainer />
                )}
            </Grid.Column>
        </Grid>
    );
};

export default InvoicePageCreate;
